export default __webpack_public_path__ + "static/media/path.d0213a39.svg";